export default __webpack_public_path__ + "static/media/LojaKahshStoreWeb.4b486f8b.png";